export const TERMS_OF_SERVICE = `
제1조 (목적)
이 약관은 꿰다(이하 "회사"라 합니다)가 제공하는 셀러헬퍼 웹서비스(이하 "서비스")의 이용조건 및 절차, 이용자와 회사 간의 권리, 의무 및 책임사항을 규정함을 목적으로 합니다.

제2조 (정의)
1. "서비스"란 회사가 인터넷을 통해 제공하는 주문서 자동화 및 고객 관리 기능 등을 의미합니다.
2. "이용자"란 본 약관에 따라 회사가 제공하는 서비스를 이용하는 자를 말합니다.
3. "회원"이란 회사가 제공하는 소셜 로그인 방식(OAuth 등)을 통해 인증을 완료하고 서비스를 이용하는 자를 말합니다."
4. "비회원"은 로그인 없이 일부 기능을 제한적으로 이용하는 자를 말합니다.

제3조 (약관의 효력 및 변경)
1. 본 약관은 서비스 화면에 게시하거나 기타의 방법으로 이용자에게 공지함으로써 효력이 발생합니다.
2. 회사는 필요한 경우 관련 법령을 위배하지 않는 범위에서 본 약관을 개정할 수 있습니다. 변경된 약관은 공지 후 효력이 발생하며, 이용자가 변경에 동의하지 않을 경우 서비스 이용을 중단할 수 있습니다.

제4조 (서비스 이용시간)
서비스는 연중무휴, 1일 24시간 제공됨을 원칙으로 합니다. 단, 시스템 점검, 서버 장애, 기타 불가항력적인 사유가 있는 경우 서비스가 일시 중단될 수 있으며, 회사는 이를 사전 또는 사후 공지합니다.

제5조 (서비스 내용)
회사는 다음 각 호의 기능을 제공합니다.
1. 고객 주문서 자동 작성 및 메시지 생성
2. 클립보드 복사 기능
3. 주문 내역 기반 엑셀 다운로드
4. 기타 회사가 개발하거나 제공하는 기능 일체

제6조 (이용자의 의무)
1. 이용자는 관련 법령과 본 약관의 규정을 준수하여야 하며, 회사의 업무에 방해되는 행위를 해서는 안 됩니다.
2. 타인의 정보를 무단으로 도용하거나 허위로 입력해서는 안 되며, 자동화된 수단으로 데이터를 수집하는 행위를 금지합니다.
3. 서비스의 기능을 정상적인 목적 외의 용도로 사용하는 것을 금지합니다.

제7조 (회사의 의무)
1. 회사는 서비스 제공과 관련하여 수집한 이용자의 개인정보를 관련 법령에 따라 보호하며, 개인정보처리방침에 따라 처리합니다.
2. 회사는 안정적인 서비스 제공을 위해 최선의 노력을 다하며, 보안 유지 및 오류 최소화를 위해 합리적인 기술적 조치를 시행합니다.

제8조 (계약 해지 및 이용 제한)
1. 이용자는 언제든지 서비스 이용을 중단할 수 있으며, 회원의 경우 계정 탈퇴를 통해 이용계약을 해지할 수 있습니다.
2. 회사는 이용자가 본 약관을 위반하거나 불법적인 행위를 한 경우, 사전 통보 없이 서비스 이용을 제한하거나 계약을 해지할 수 있습니다.

제9조 (지적재산권)
1. 회사가 서비스 내에서 제작한 UI, 텍스트, 템플릿, 기능 구조 등에 대한 저작권 및 지적재산권은 회사에 귀속됩니다.
2. 이용자는 회사의 사전 동의 없이 위 내용을 복제, 배포, 전송하거나 상업적으로 이용할 수 없습니다.

제10조 (유료 서비스 및 결제)
1. 회사는 일부 기능에 대해 유료 구독을 통해 서비스를 제공할 수 있으며, 구체적인 요금제, 결제 방식, 환불 정책 등은 별도 고지합니다.
2. 결제는 회사가 연동한 PG사(토스페이먼츠 등)를 통해 안전하게 처리됩니다.
3. 환불은 결제일로부터 결제일을 포함한 7일 동안에 한해 가능하며, 자세한 기준은 환불정책에 따릅니다.

제11조 (환불 정책)
1. 이용자가 유료 구독 상품을 구매한 경우, 다음의 조건을 모두 만족하는 경우에 한해 전액 환불을 요청할 수 있습니다:
- 결제일로부터 7일 이내일 것  
- 배송 엑셀 페이지의 자동 정리 기능 사용 횟수가 10회 미만일 것
- 정산서 페이지의 메시지 복사 기능 사용 횟수가 10회 미만일 것
2. 배송 엑셀 페이지의 자동 정리 기능 또는 정산서 페이지의 메시지 복사 기능 사용 이력이 10회 이상이거나, 결제일로부터 7일이 경과한 경우에는 환불이 불가합니다.
3. 회사는 부분 환불을 지원하지 않으며, 해지 시 결제된 기간 동안의 서비스는 정상적으로 제공됩니다. 자동 결제는 다음 결제일부터 중단됩니다.
4. 환불 요청은 이메일(contact@queddar.com) 또는 채팅 문의를 통해 접수할 수 있으며, 회사는 영업일 기준 3일 이내에 처리 여부를 회신합니다.
5. 기타 환불 관련 기준은 「전자상거래 등에서의 소비자보호에 관한 법률」 및 「소비자분쟁해결기준」을 따릅니다.

제12조 (전자금융거래 관련 조항)
1. 본 조항은 회사가 제공하는 전자지급결제대행서비스 및 전자금융거래와 관련하여 적용됩니다.
2. 회사는 PG사를 통한 결제 수단을 제공합니다.
3. 결제 중 오류가 발생한 경우 이용자는 즉시 정정을 요청할 수 있으며, 회사는 신속히 대응합니다.
4. 회사는 이용자의 결제 정보를 안전하게 보호하기 위한 보안 시스템을 유지합니다.
5. 전자금융거래 기록은 관련 법령에 따라 5년간 보관되며, 이용자는 열람을 요청할 수 있습니다.

제13조 (면책조항)
1. 회사는 천재지변, 불가항력, 통신장애 등 회사의 책임 없는 사유로 인한 서비스 중단에 대해 책임을 지지 않습니다.
2. 회사는 이용자의 귀책 사유로 인한 서비스 이용 장애에 대해 책임을 지지 않습니다.
3. 회사는 이용자가 서비스에 게재한 정보의 정확성, 신뢰성에 대해 보증하지 않으며, 그로 인해 발생한 문제는 이용자 본인의 책임입니다.

제14조 (분쟁 해결 및 준거법)
1. 본 약관은 대한민국 법령에 따라 해석되며, 회사와 이용자 간 발생한 분쟁에 대해서는 서울중앙지방법원을 제1심 관할법원으로 합니다.

부칙  
본 약관은 2025년 4월 19일부터 시행합니다.
`;


export const PRIVACY_POLICY = `
제1조 (수집하는 개인정보 항목)
회사는 셀러헬퍼 서비스 제공을 위하여 아래와 같은 개인정보를 수집할 수 있습니다.

1. 현재 수집 중인 항목
- 이메일 (회원가입 및 로그인용)
- 닉네임 (고객 주문 확인용, 통계 기능 제공 목적)
- 비회원 이용 시 임시 식별자 (pseudo user ID)

2. 향후 수집될 수 있는 항목 (유료 결제 연동 시)
- 이름, 전화번호, 결제수단 정보 (PG사 요구에 따라)
- 서비스 이용 기록 및 접속 로그 (부정 이용 방지 목적)

제2조 (개인정보의 수집 및 이용 목적)
회사는 수집한 개인정보를 다음의 목적을 위해 사용합니다.

1. 회원가입 및 본인 확인
2. 셀러 대상 서비스 제공 및 사용 이력 관리
3. 고객 문의 및 오류 응대
4. 향후 유료 서비스 결제 처리 및 영수증 발송 (예정)
5. 불법/비정상 이용 방지 및 통계 분석

제3조 (개인정보 보유 및 이용 기간)
회사는 수집된 개인정보를 아래 기준에 따라 보관 및 파기합니다.

1. 회원 탈퇴 시 즉시 파기
2. 법령에 따라 일정 기간 보존이 필요한 경우 해당 기간 동안 보관
3. 비회원 임시 사용자 정보는 30일 이내 파기

제4조 (개인정보의 제3자 제공)
회사는 원칙적으로 이용자의 개인정보를 외부에 제공하지 않으며,  
다만 결제처리 등을 위해 PG사(예: 토스페이먼츠)에 필요한 정보를 제공할 수 있습니다.

제5조 (개인정보 처리 위탁)
회사는 서비스 운영을 위해 다음과 같이 개인정보 처리를 위탁할 수 있습니다.

- 결제 처리: PG사(토스페이먼츠 등)
- 호스팅: Amazon Web Services (AWS)

제6조 (이용자의 권리와 행사 방법)
이용자는 언제든지 자신의 개인정보에 대해 열람, 정정, 삭제, 처리 정지 등을 요청할 수 있습니다.  
요청은 고객센터 또는 이메일(contact@queddar.com)로 접수할 수 있습니다.

제7조 (개인정보 보호책임자)
회사는 개인정보 관련 문의 처리를 위해 아래와 같이 개인정보 보호책임자를 지정합니다.

- 성명: 김태완  
- 이메일: contact@queddar.com

본 방침은 2025년 4월 19일부터 시행됩니다.
`;
